import React from 'react';
import styles from './reviewSearchAndKeywordsStyles.module.scss';

type ReviewsSearchInputProps = {
  searchTerm: string | undefined;
  setSearchTerm: React.Dispatch<React.SetStateAction<string | undefined>>;
};

const ReviewsSearchInput: React.FC<ReviewsSearchInputProps> = ({ searchTerm, setSearchTerm }) => {
  const handleChange = (e: React.FormEvent<HTMLInputElement>) => {
    let value = (e.target as HTMLInputElement).value;
    value = value.replace(/[^a-zA-Z0-9 ]/g, '').trimStart();
    setSearchTerm(value);
  };

  return (
    <div className={`yoga-ui-text-input ${styles.searchBarWrapper}`}>
      <div className={`icon ${styles.searchIconWrapper}`}>
        <div className={`icon ${styles.searchIcon}`}></div>
      </div>
      <input
        id="reviews-search"
        className={`${styles.searchInputWrapper}`}
        value={searchTerm || ''}
        placeholder="Search Reviews"
        onChange={handleChange}
        type="search"
      />
      <label>Search Reviews</label>
      {searchTerm && (
        <button
          className={`icon ${styles.closeIconWrapper}`}
          onClick={() => setSearchTerm('')}
          type="button"
          aria-label="Clear Search"
        >
          <div className={`icon ${styles.closeIcon}`}></div>
        </button>
      )}
    </div>
  );
};

export default ReviewsSearchInput;
